/**
 * Generates the required accessibility (A11y) properties for a tab element.
 *
 * @param {number|string} idx - The index used to generate unique IDs for the tab.
 * @returns {{ id: string, 'aria-controls': string }}
 *   An object containing A11y attributes for identifying and linking a tab
 *   to its corresponding tab panel.
 *
 */
export const tabA11yPropInjector = (idx) => {
    return {
        id: `simple-tab-${idx}`,
        'aria-controls': `simple-tabpanel-${idx}`,
    };
}

/**
 * Generates accessibility (A11y) properties for an associated tab panel element.
 *
 * @function tabPanelA11yPropInjector
 * @param {number|string} idx - The index used to generate unique IDs for the panel.
 * @returns {{ role: string, id: string, 'aria-labelledby': string }}
 *   An object containing A11y attributes required for screen readers to recognize
 *   the panel and associate it with its controlling tab.
 *
 */
export const tabPanelA11yPropInjector = (idx) => {
    return {
        role: "tabpanel",
        id: `simple-tabpanel-${idx}`,
        'aria-labelledby': `simple-tab-${idx}`
    };
}